module.exports = __webpack_public_path__ + "img/Certificate-of-Achievement.fcc17a0c.png";